import { Component, HostListener, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant } from 'src/app/constants/common-constant';
import { CommonService } from 'src/app/services/common/common.service';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { DirtycheckDialogboxComponent } from '../../dirtycheck-dialogbox/dirtycheck-dialogbox.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CollegeConstant } from 'src/app/constants/label-constants';
import { collegeErrorPageMessage, commonErrorMessage } from 'src/app/constants/error-message-constant';

@Component({
  selector: 'app-collage-add-edit',
  templateUrl: './college-add-edit.component.html',
  styleUrls: ['./college-add-edit.component.scss']
})
export class CollegeAddEditComponent {
  CollageForm: FormGroup = this.formBuilder.group({});
  @Input() collegeId: any;
  CommonConstant: any = [];
  stateList: any[] = [];
  cityList: any[] = [];
  CollegeConstant: any = [];
  CollegePhoto: any;
  collegeLogo: string = '';
  flag: boolean = true;
  errorMessage: any = [];
  commonErrorMessage: any = [];
  modalButton: boolean = false;
  protected _onDestroy = new Subject();
  public FilterCtrl: FormControl = new FormControl();
  public filteredData: ReplaySubject<any> = new ReplaySubject();
  public CityFilterCtrl: FormControl = new FormControl();
  public cityFilteredData: ReplaySubject<any> = new ReplaySubject();
  @HostListener('window:beforeunload', ['$event'])
  public canDeactivate(event: BeforeUnloadEvent): void {
    if (this.CollageForm.dirty) {
      event.preventDefault();
      event.returnValue = false;
    }
  }

  constructor(
    private formBuilder: FormBuilder,
    private CommonService: CommonService,
    private toastr: ToastrService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    public modalService: NgbActiveModal,
    public ModalService: NgbModal,
  ) { }
  protected filterstates() {
    if (!this.stateList) {
      return;
    }
    let search = this.FilterCtrl.value;
    if (!search) {
      this.filteredData.next(this.stateList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredData.next(
      this.stateList.filter(
        (data) => data.value.toLowerCase().indexOf(search) > -1
      )
    );
  }
  protected filtercity() {
    if (!this.cityList) {
      return;
    }
    let search = this.CityFilterCtrl.value;
    if (!search) {
      this.cityFilteredData.next(this.cityList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.cityFilteredData.next(
      this.cityList.filter(
        (data) => data.value.toLowerCase().indexOf(search) > -1
      )
    );
  }

  ngOnDestroy() {
    this._onDestroy.next(1);
    this._onDestroy.complete();
  }

  ngOnInit(): void {
    this.CommonConstant = CommonConstant;
    this.CollegeConstant = CollegeConstant;
    this.errorMessage = collegeErrorPageMessage;
    this.commonErrorMessage = commonErrorMessage;
    this.onInitCollageForm();
    this.getStateList();
    this.filteredData.next(this.stateList.slice());
    this.FilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterstates();
      });
    if (this.collegeId > 0) {
      this.getCollageDetail(this.collegeId);

    }
    else {
      this.collegeId = 0;
    }
  }

  onInitCollageForm() {
    this.CollageForm = this.formBuilder.group({
      CollegeId: [0],
      CollegeName: ['', [Validators.required, Validators.maxLength(100)]],
      MobileNo: ['', [Validators.required, Validators.pattern(/^[6-9][0-9]{9}$/)]],
      CityId: ['', [Validators.required]],
      StateId: ['', [Validators.required]],
      CollegeLogo: ['']
    });
  }

  get collageFormControl() {
    return this.CollageForm.controls;
  }

  onCancel() {
    if (this.CollageForm.dirty) {
      const modalRef = this.ModalService.open(DirtycheckDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
      modalRef.componentInstance.CollageForm = this.CollageForm;
    }
    else {
      this.modalService.close();
    }
  }

  getCollageDetail(CollageId: number) {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.college.GetCollegeById.replace("{id}", CollageId.toString());
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: async (data) => {
        this.spinner.hide();
        if (data.data.collegeLogo) {
          (<HTMLInputElement>document.getElementById('CollegeProfilePreview')).setAttribute("src", data.data.collegeLogo);
        }
        else {
          (<HTMLInputElement>document.getElementById('CollegeProfilePreview')).setAttribute("src", "assets/img/logo_placeholder.svg");
        }
        await this.getCityByStateId(data.data.stateId)
        this.setCollageForm(data.data);
      },
      error: (err) => {
        console.log('getCollageDetail-Error', err);
      }
    });
  }

  setCollageForm(data) {
    this.CollageForm.setValue({
      CollegeId: (data.collegeId) ? data.collegeId : 0,
      CollegeName: data.collegeName,
      MobileNo: data.mobileNo,
      StateId: data.stateId,
      CityId: data.cityId,
      CollegeLogo: data.collegeLogo ? data.collegeLogo : ''
    });
    this.collegeLogo = data.collegeLogo;
  }

  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  async getStateList() {
    const apiUrl = this.apiUrl.apiUrl.job.GetStateList;
    this.CommonService.doGet(apiUrl)
      .pipe()
      .subscribe({
        next: (data) => {
          if (data && data.data && data.data.length > 0) {
            for (let i = 0; i < data.data.length; i++) {
              this.stateList.push({
                id: data.data[i].stateId,
                value: data.data[i].name,
              });
            }
            this.filterstates();
          }
        },
        error: (err) => {
          console.log('getHandlerList-Error', err);
        }
      });
  }

  getCityByStateId(id: any) {
    const selectedStateId = this.CollageForm.get('StateId')?.value;
    this.CollageForm.controls['CityId'].setValue('');
    console.log(selectedStateId);
    if (selectedStateId?.value !== null) {
      this.CollageForm.get('CityId')?.enable();
    } else {
      this.CollageForm.get('CityId')?.disable();
    }
    let stateId = id;
    this.cityList = [];
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.job.GetCityByStateId.replace(
      '{stateId}',
      stateId.toString()
    );
    this.CommonService.doGet(apiUrl)
      .pipe()
      .subscribe({
        next: (data) => {
          if (data && data.data && data.data.length > 0) {
            for (let i = 0; i < data.data.length; i++) {
              this.cityList.push({
                id: data.data[i].cityId,
                value: data.data[i].name,
              });
            }
            this.cityFilteredData.next(this.cityList.slice());
            this.CityFilterCtrl.valueChanges
              .pipe(takeUntil(this._onDestroy))
              .subscribe(() => {
                this.filtercity();
              });
            this.filtercity();
          }
          this.spinner.hide();
        },
        error: (err) => {
          console.log('getHandlerList-Error', err);
        }
      });
  }

  saveCollage() {
    this.modalButton = true;
    if (!this.CollageForm.valid) {
      return;
    }
    this.spinner.show();
    const form = new FormData();
    this.spinner.show();
    form.append('collegeId', this.CollageForm.value.CollegeId ? this.CollageForm.value.CollegeId.toString() : '0');
    form.append('collegeName', this.CollageForm.value.CollegeName.trim());
    form.append('mobileNo', this.CollageForm.value.MobileNo.trim());
    form.append('CityId', this.CollageForm.value.CityId);
    form.append('StateId', this.CollageForm.value.StateId);
    form.append("CollegePhoto", this.CollegePhoto);
    form.append("CollegeLogo", this.collegeLogo);
    const apiUrl = this.apiUrl.apiUrl.college.SaveCollege;
    this.CommonService.doPost(apiUrl, form).pipe().subscribe({
      next: (data) => {
        if (data.success) {
          this.modalButton = false;
          this.spinner.hide();
          this.modalService.close('save');
          this.toastr.success(data.message);
        }
        else {
          this.spinner.hide();
          this.toastr.error(data.message);
          this.modalButton = false;
        }
      },
      error: (er) => {
        console.error(er)
      }
    });
  }

  onFileChanged(event: any) {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      let file: any;
      var ext = event.target.files[0].name.match(/\.([^\.]+)$/)[1];
      switch (ext.toLowerCase()) {
        case 'jpg':
        case 'jpeg':
        case 'png':
          break;
        default:
          this.toastr.error("Invalid Image", "Please select only JPG or PNG Image");
          (<HTMLInputElement>document.getElementById('uploadCompanyImage')).value = "";
          return true;
      }
      reader.onload = function (e) {
        file = e.target;
        (<HTMLInputElement>document.getElementById('CollegeProfilePreview')).setAttribute("src", file.result);
      }
      reader.readAsDataURL(event.target.files[0]);
      this.CollegePhoto = event.target.files[0];
    } else {
      (<HTMLInputElement>document.getElementById('CollegeProfilePreview')).setAttribute("src", "assets/img/logo_placeholder.svg");
      this.CollegePhoto = null;
      (<HTMLInputElement>document.getElementById('uploadCompanyImage')).value = '';
      this.CollegePhoto.controls['CompanyLogo'].setValue('');
    }
  }
}
